import { useInfiniteQuery } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { FEED_QK } from '@/hooks/use-comunicado-mutations';
import type { FeedItem } from '@/components/comunicados/types';

const PER_PAGE = 20;

type FeedResponse = {
  items: FeedItem[];
  page: number;
  per_page: number;
};

export function useComunicadosFeed() {
  return useInfiniteQuery({
    queryKey: FEED_QK,
    initialPageParam: 1,
    queryFn: ({ pageParam }) =>
      pb.send<FeedResponse>(`/api/comunicados/feed?page=${pageParam}`, {
        method: 'GET',
      }),
    getNextPageParam: (last) =>
      last.items.length < PER_PAGE ? undefined : last.page + 1,
  });
}
